"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToDateSGE2 = void 0;
const date_fns_1 = require("date-fns");
const numberToDateSGE2 = (str) => {
    try {
        let dataSenha = null;
        if (str.replace(/\D/g, '').length === 6) {
            const pw = str.replace(/\D/g, '');
            dataSenha = (parseInt(pw.substr(4, 2)) > 25 ? '19' : '20').concat(pw.substr(4, 2), '-', pw.substr(2, 2), '-', pw.substr(0, 2));
        }
        else if (str.replace(/\D/g, '').length === 8) {
            const pw = str.replace(/\D/g, '');
            dataSenha = pw.substr(4, 4).concat('-', pw.substr(2, 2), '-', pw.substr(0, 2));
        }
        if (dataSenha) {
            (0, date_fns_1.parseISO)(dataSenha).toISOString();
        }
        return dataSenha;
    }
    catch (error) {
        return null;
    }
};
exports.numberToDateSGE2 = numberToDateSGE2;
